export default __webpack_public_path__ + "78c95b24.mp3";